window.storefrontApi = window.storefrontApi || {};

const FETCH_CHUNK_SIZE = 25;

window.storefrontApi.PRODUCT_TILE_BADGES_QUERY = `
query fetchProductTileBadges($ids: [ID!]!) @inContext(country: ${
  Shopify.country
}, language: ${Shopify.locale.toUpperCase()}) {
  nodes(ids: $ids) {
    ... on Product {
      id
      metafields(
        identifiers: [
          { namespace: "pim", key: "collaboration" },
          { namespace: "pim", key: "bestseller_us" },
          { namespace: "pim", key: "bestseller_ca" },
          { namespace: "pim", key: "trending_us" },
          { namespace: "pim", key: "trending_ca" },
          { namespace: "pim", key: "isNewArrivalUS" },
          { namespace: "pim", key: "isNewArrivalCA" },
          { namespace: "pim", key: "socialConfidence" },
          { namespace: "pim", key: "sellingFastUS" },
          { namespace: "pim", key: "sellingFastCA" },
        ]
      ) {
        value
        key
      }
    }
  }
}`;

window.storefrontApi.PRODUCT_CARD_QUERY = `
query fetchCompanionProducts($ids: [ID!]!) @inContext(country: ${
  Shopify.country
}, language: ${Shopify.locale.toUpperCase()}) {
  nodes(ids: $ids) {
    ... on Product {
      handle
      id
      totalInventory
      tags
      title
      availableForSale
      productType
      publishedAt
      featuredImage {
        url(transform: { maxHeight: 500, maxWidth: 500 })
      }
      selectedOrFirstAvailableVariant {
        quantityAvailable
      }
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      companionProducts: metafield(namespace: "pim", key: "companionProducts") {
        value
        reference {
          ... on Metaobject {
            field(key: "product_json") {
              value
            }
          }
        }
      }
      metafields(
        identifiers: [
          { namespace: "custom", key: "highlights" },
          { namespace: "custom", key: "media_gallery_assets" },
          { namespace: "custom", key: "low_stock_value" },
          { namespace: "custom", key: "publish_date_us" },
          { namespace: "custom", key: "publish_date_ca" },
          { namespace: "custom", key: "non_returnable_type" },
          { namespace: "custom", key: "silhouette" },
          { namespace: "custom", key: "color" },
          { namespace: "custom", key: "gender" },
          { namespace: "custom", key: "category" },
          { namespace: "custom", key: "promotional_message_us_en" },
          { namespace: "custom", key: "promotional_message_ca_en" },
          { namespace: "custom", key: "promotional_message_ca_fr" },
          { namespace: "custom", key: "promo_applied_message_us_en" },
          { namespace: "custom", key: "promo_applied_message_ca_en" },
          { namespace: "custom", key: "promo_applied_message_ca_fr" },
          { namespace: "pim", key: "collaboration" },
          { namespace: "pim", key: "heelType" },
          { namespace: "pim", key: "crewExclusivePriceCA" },
          { namespace: "pim", key: "crewExclusivePriceUS" },
          { namespace: "pim", key: "onlineExclusive" },
          { namespace: "pim", key: "loyaltyEarlyBuyUS" },
          { namespace: "pim", key: "loyaltyEarlyBuyEndDateUS" },
          { namespace: "pim", key: "loyaltyEarlyBuyEndDateCA" },
          { namespace: "pim", key: "loyaltyEarlyBuyCA" },
          { namespace: "pim", key: "comingSoonUS" },
          { namespace: "pim", key: "comingSoonCA" },
          { namespace: "pim", key: "preOrderUS" },
          { namespace: "pim", key: "preOrderCA" },
          { namespace: "pim", key: "bestseller_us" },
          { namespace: "pim", key: "bestseller_ca" },
          { namespace: "pim", key: "trending_us" },
          { namespace: "pim", key: "trending_ca" },
          { namespace: "pim", key: "isNewArrivalUS" },
          { namespace: "pim", key: "isNewArrivalCA" },
          { namespace: "pim", key: "socialConfidence" },
          { namespace: "pim", key: "sellingFastUS" },
          { namespace: "pim", key: "sellingFastCA" },
        ]
      ) {
        value
        key
        reference {
          ... on MediaImage {
            id
            image {
              altText
              src
              height
              width
            }
          }
        }
      }
    }
  }
}`;

window.storefrontApi.PDP_RECO_PRODUCT_CONTEXT_QUERY = `query PdpRecoProductFilterContext($productId: ID!) @inContext(country: ${
  Shopify.country
}, language: ${Shopify.locale.toUpperCase()}) {
  product(id: $productId) {
    id
    colorMetafield: metafield(namespace: "custom", key: "color") {
      value
    }
    genderMetafield: metafield(namespace: "custom", key: "gender") {
      value
    }
    silhouetteMetafield: metafield(namespace: "custom", key: "silhouette") {
      value
    }
    categoryMetafield: metafield(namespace: "custom", key: "category") {
      value
    }
  }
}`;

window.storefrontApi.PRODUCT_DATA_SWATCHES_PDP = `query fetchProductData($ids: [ID!]!) @inContext(country: ${
  Shopify.country
}, language: ${Shopify.locale.toUpperCase()}) {
  nodes(ids: $ids) {
    ... on Product {
      id
      handle
      totalInventory
      metafields(
        identifiers: [
          { namespace: "pim", key: "comingSoonUS" },
          { namespace: "pim", key: "comingSoonCA" }
        ]
      ) {
        value
        key
      }
      variants(first: 250) {
        edges {
          node {
            id
            availableForSale
            selectedOptions {
              value
            }
            sku
          }
        }
      }
    }
  }
}`;

window.storefrontApi.QUICK_ADD_PRODUCT_QUERY = `query fetchQuickAddProduct($ids: [ID!]!) @inContext(country: ${
  Shopify.country
}, language: ${Shopify.locale.toUpperCase()}) {
  nodes(ids: $ids) {
    ... on Product {
      id
      handle
      title
      tags
      isGiftCard
      availableForSale
      featuredImage {
        url
        altText
        width
        height
      }
      selectedOrFirstAvailableVariant {
        availableForSale
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
      }
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      options {
        name
        values
      }
      variants(first: 250) {
        edges {
          node {
            id
            availableForSale
            quantityAvailable
            selectedOptions {
              name
              value
            }
          }
        }
      }
      metafields(
        identifiers: [
          { namespace: "custom", key: "gender" },
          { namespace: "custom", key: "promotional_message_us_en" },
          { namespace: "custom", key: "promotional_message_ca_en" },
          { namespace: "custom", key: "promotional_message_ca_fr" },
          { namespace: "custom", key: "promo_applied_message_us_en" },
          { namespace: "custom", key: "promo_applied_message_ca_en" },
          { namespace: "custom", key: "promo_applied_message_ca_fr" },
          { namespace: "custom", key: "non_returnable_type" },
          { namespace: "pim", key: "sizeRecommendation" },
          { namespace: "pim", key: "sizeRecommendationMessage" },
          { namespace: "pim", key: "kidsAge" },
          { namespace: "pim", key: "crewExclusivePriceCA" },
          { namespace: "pim", key: "crewExclusivePriceUS" },
          { namespace: "pim", key: "onlineExclusive" },
          { namespace: "pim", key: "loyaltyEarlyBuyUS" },
          { namespace: "pim", key: "loyaltyEarlyBuyEndDateUS" },
          { namespace: "pim", key: "loyaltyEarlyBuyEndDateCA" },
          { namespace: "pim", key: "loyaltyEarlyBuyCA" },
          { namespace: "pim", key: "comingSoonUS" },
          { namespace: "pim", key: "comingSoonCA" },
          { namespace: "pim", key: "comingSoonReleaseDateUS" },
          { namespace: "pim", key: "comingSoonReleaseDateCA" },
          { namespace: "pim", key: "preOrderUS" },
          { namespace: "pim", key: "preOrderCA" }
        ]
      ) {
        key
        value
      }
    }
  }
}`;

window.storefrontApi.QUICK_ADD_COMPANION_QUERY = `query fetchQuickAddCompanion($ids: [ID!]!) @inContext(country: ${
  Shopify.country
}, language: ${Shopify.locale.toUpperCase()}) {
  nodes(ids: $ids) {
    ... on Product {
      id
      availableForSale
      featuredImage {
        url
        altText
      }
    }
  }
}`;

window.storefrontApi.QUICK_ADD_PRODUCT_FALLBACK_QUERY = `query fetchQuickAddProductFallback($ids: [ID!]!) @inContext(country: ${
  Shopify.country
}, language: ${Shopify.locale.toUpperCase()}) {
  nodes(ids: $ids) {
    ... on Product {
      id
      handle
      title
      isGiftCard
      availableForSale
      featuredImage {
        url
        altText
        width
        height
      }
      selectedOrFirstAvailableVariant {
        availableForSale
        price {
          amount
          currencyCode
        }
        compareAtPrice {
          amount
          currencyCode
        }
      }
      priceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      compareAtPriceRange {
        maxVariantPrice {
          amount
          currencyCode
        }
      }
      options {
        name
        values
      }
      variants(first: 250) {
        edges {
          node {
            id
            availableForSale
            quantityAvailable
            selectedOptions {
              name
              value
            }
          }
        }
      }
      metafields(
        identifiers: [
          { namespace: "custom", key: "gender" },
          { namespace: "pim", key: "sizeRecommendation" },
          { namespace: "pim", key: "sizeRecommendationMessage" },
          { namespace: "pim", key: "kidsAge" }
        ]
      ) {
        key
        value
      }
    }
  }
}`;

(() => {
  let badgeBatchService;
  let cardBatchService;

  window.storefrontApi.getProductBadgeBatchService = () => {
    if (!badgeBatchService) {
      badgeBatchService = window.storefrontApi.createNodesChunkedProductsService({
        query: window.storefrontApi.PRODUCT_TILE_BADGES_QUERY,
        chunkSize: FETCH_CHUNK_SIZE,
        flushDelay: 16,
      });
    }

    return badgeBatchService;
  };

  window.storefrontApi.getProductCardBatchService = () => {
    if (!cardBatchService) {
      cardBatchService = window.storefrontApi.createNodesChunkedProductsService({
        query: window.storefrontApi.PRODUCT_CARD_QUERY,
        chunkSize: FETCH_CHUNK_SIZE,
        flushDelay: 30,
      });
    }

    return cardBatchService;
  };
})();
